import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/buyer-fe-next-export/src/app/providers.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/buyer-fe-next-export/src/app/warpPage.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/buyer-fe-next-export/src/styles/globals.scss");
